import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';


const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Applications,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Applications,
        loadComponent: () =>
            import('./features/applications/applications.component').then(
                (m) => m.ApplicationsComponent,
            ),
        canLoad: [AuthGuard],
        title: marker('modules.applications.head'),
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
